import Vue from 'vue'
//引入vuex
import Vuex from 'vuex'
//vuex持久化
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    corpId: '', //学校ID
    menuId: '', //打开菜单的ID
    dyProgramme:{},//当前创建的选课计划
    projectType:'',
    projectId:'',
    rangeType:'',
    selectedTreeNode:{},
    rangeType:'',
    menuObject:{}, //菜单管理
    menuIndex:{}, //个人办公菜单
    menuApply:{}, //系统管理菜单
    roleId:'',
    menuIndexId: '',
    menuChild:[], //三级菜单
    xnxqId:'',
    xnxqList:[],
    levelList:[],
    zyfxList:[],
    rkapParam:{},
    cjdInfo:{}
  },
  mutations: {
    setCorpId(state,corpId) {
      state.corpId = corpId
    },
    setMenuId(state,menuId) {
      state.menuId = menuId
    },
    setDyProgramme(state,dyProgramme){
      state.dyProgramme = dyProgramme;
    },
    setProjectType(state,projectType){
      state.projectType = projectType;
    },
    setProjectId(state,projectId){
      state.projectId = projectId;
    },
    setRangeType(state,rangeType){
      state.rangeType = rangeType;
    },
    setSelectedTreeNode(state,selectedTreeNode){
      state.selectedTreeNode = selectedTreeNode
    },
    setMenuObject(state,menuObject) {
      state.menuObject = menuObject;
    },
    setMenuIndex(state,menuIndex) {
      state.menuIndex = menuIndex;
    },
    setMenuApply(state,menuApply) {
      state.menuApply = menuApply;
    },
    setRoleId(state,roleId){
      state.roleId = roleId;
    },
    setMenuChild(state,menuChild){
      state.menuChild = menuChild;
    },
    setXnxqId(state,xnxqId){
      state.xnxqId = xnxqId
    },
    setXnxqList(state,xnxqList){
      state.xnxqList = xnxqList;
    },
    setLevelList(state,levelList){
      state.levelList = levelList
    },
    setZyfxList(state,zyfxList){
      state.zyfxList = zyfxList
    },
    setRkapParam(state,rkapParam){
      state.rkapParam = rkapParam
    },
    setMenuIndexId(state,menuIndexId){
      state.menuIndexId = menuIndexId
    },
    setCjdInfo(state,cjdInfo){
      state.cjdInfo = cjdInfo
    }
  },
  plugins: [createPersistedState()]
})

//放入：this.$store.commit("setProjectType","1");
//获取：this.$store.state.projectType



// WEBPACK FOOTER //
// ./src/store/index.js